<div class="outer-wrapper">
  <app-header></app-header>
  <div class="container-fluid pl-0 pr-0" [hidden]="loader">
    <div class="row ml-0 mr-0">
      <div
        *ngIf="currentpage <= 6"
        class="col-md-2 bg-light left-menu shadow-sm side-items animate__animated animate__fadeInLeft"
      >
        <div>
          <h3 class="mt-5">Profile</h3>
          <ul class="ml-3">
            <li
              (click)="onClickItem(1)"
              [ngClass]="currentpage == 1 ? 'active-item' : ''"
            >
              <span
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
                  /></svg></span
              >Personal Details
            </li>
            <li
              (click)="onClickItem(2)"
              [ngClass]="currentpage == 2 ? 'active-item' : ''"
            >
              <span
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
                  /></svg></span
              >Contact Details
            </li>
            <li
              (click)="onClickItem(3)"
              [ngClass]="currentpage == 3 ? 'active-item' : ''"
            >
              <span
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
                  /></svg></span
              >Location
            </li>
            <!-- <li (click)="onClickItem(4)" [ngClass]="currentpage==4?'active-item':''"><span><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
             <path stroke-linecap="round" stroke-linejoin="round" d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" />
           </svg></span>EFC/AGI</li> -->
          </ul>
          <h3 class="mt-4">Academic</h3>
          <ul class="ml-3 mr-4">
            <li
              (click)="onClickItem(4)"
              [ngClass]="currentpage == 4 ? 'active-item' : ''"
            >
              <span
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25"
                  /></svg></span
              >High School
            </li>
            <li
              (click)="onClickItem(5)"
              [ngClass]="currentpage == 5 ? 'active-item' : ''"
            >
              <span
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z"
                  /></svg></span
              >Desired Field of Study
            </li>
            <li
              (click)="onClickItem(6)"
              [ngClass]="currentpage == 6 ? 'active-item' : ''"
            >
              <span
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 01-1.125-1.125v-3.75zM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-8.25zM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-2.25z"
                  />
                </svg> </span
              >Merit
            </li>
          </ul>
        </div>
      </div>
      <div
        [ngClass]="currentpage <= 6 ? 'col-md-10 right-content' : 'col-md-12 '"
      >
        <div class="page-content mt-4 mx-4 w-auto">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>
  <!-- Extra added below -->
  <div class="mx-auto" [hidden]="!loader">
    <div class="in-container">
      <div class="row">
        <div class="col-md-6 text-center mx-auto">
          <div
            id="loading-text"
            class="loading-text"
            [innerHtml]="loaderText"
          ></div>
          <div id="loading-text" class="author-text" [innerHtml]="author"></div>
          <img src="./assets/images/loader.gif" width="90" />
        </div>
      </div>
    </div>
  </div>
  <!-- Extra added above -->
  <app-footer></app-footer>
</div>
